import { cloneElement, Fragment, ReactElement, ReactNode } from 'react'

export interface ListRenderProps<T> {
    items: T[]
    render: (item: T) => ReactNode
    wrapper?: ReactElement
}

export const ListRender = <T,>({
    items,
    render,
    wrapper = <Fragment />,
}: ListRenderProps<T>): ReactElement => {
    const listItems = items.map((item) => render(item))
    return cloneElement(wrapper, wrapper.props, listItems)
}
